import { getAmplitudeInstance } from '../amplitudeHelpers';
import VoteAction from '../enums/VoteAction';

type logReviewHelpfulVoteUpdatedParams = {
  review_id: string;
  trail_id: string;
  vote_action: VoteAction;
};

/**
 * Fires when a signed-in user clicks the helpful/upvote control on a trail review to add or remove their upvote on the Trail Page.
 * @param params - Attributes to log with the amplitude event
 * @param params.review_id - ID of the review being voted on
 * @param params.trail_id - ID of the trail whose review is being voted on
 * @param params.vote_action - Whether the user added or removed an upvote
 */
const logReviewHelpfulVoteUpdated = ({ review_id, trail_id, vote_action }: logReviewHelpfulVoteUpdatedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'review helpful vote updated',
    { 'review id': review_id, 'trail id': trail_id, 'vote action': vote_action },
    callback
  );
};

export default logReviewHelpfulVoteUpdated;
